import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
//
import { DepartmentGuard } from 'src/auth/guard';
import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  const isHorizontal = settings.themeLayout === 'horizontal';
  // const isHorizontal =  'horizontal'; // Use dynamic setting instead of hardcoded

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  if (isHorizontal) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        {/* SIDEBAR COMMENTED OUT FOR FULL WIDTH */}
        {/* {lgUp ? renderHorizontal : renderNavVertical} */}
        {/* {renderHorizontal} */}

        <DepartmentGuard>
          <Main>{children}</Main>
        </DepartmentGuard>
      </>
    );
  }

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
          }}
        >
          {/* SIDEBAR COMMENTED OUT FOR FULL WIDTH */}
          {/* {lgUp ? renderNavMini : renderNavVertical} */}

          <DepartmentGuard>
            <Main>{children}</Main>
          </DepartmentGuard>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        {/* SIDEBAR COMMENTED OUT FOR FULL WIDTH */}
        {/* {renderNavVertical} */}

        <DepartmentGuard>
          <Main>{children}</Main>
        </DepartmentGuard>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
